import gamesLogo from '../components/NewsletterSignup/variants/NewsletterSignupStandard/games-logo.svg';

const config = (category, title, description, newsletterId, logo = null) => ({
  category,
  title,
  description,
  newsletterId,
  logo, // Image URL for logo-based titles (null for text titles)
});

// Newsletter configs
// Currently only Games section posts show section-specific newsletters
// US news posts use BuzzFeedDaily instead
const CONFIGS = {
  BuzzFeedDaily: config(
    'daily',
    'BuzzFeed Daily',
    'Keep up with the latest daily buzz with the BuzzFeed Daily newsletter!',
    'buzzfeed_email_daily'
  ),
  Games: config(
    'games',
    'BuzzFeed Games', // Alt text for logo
    'Never miss a daily game again!<br><br>Get notified whenever your favorite BuzzFeed game drops — plus, discover new ones to love.',
    'buzzfeed_email_games',
    gamesLogo // Logo image imported as module
  ),
};

const configForSection = section =>
  ({
    Games: CONFIGS.Games,
  }[section]);

export function newsletterConfiguration({ edition, section, isNews }) {
  if (edition === 'US' && isNews) {
    return CONFIGS.BuzzFeedDaily;
  }

  return configForSection(section);
}

export const isEligible = (buzz) => {
  return ![
    buzz.tags.includes('--no-newsletter-signup'),
    buzz.bfpFormats.includes('newsletter_signup'),
    buzz.flags.nsfw,
    buzz.isAd,
    buzz.isShopping,
    buzz.isQuiz && buzz.isUS,
    buzz.classification.edition === 'Japan',
  ].some(x => x);
}
